/* === Kategoriemenue des Shops auf dem Handy ===
   Der Knopf „Kategorie auswaehlen" oeffnet ein bildschirmfuellendes Menue mit Ebenen —
   dieselbe Bedienung wie das Hauptmenue hinter den drei Strichen: Ein Tipp auf eine
   Oberkategorie schiebt die naechste Ebene darueber, „Zurueck" fuehrt eine Ebene hoch.
   Geschlossen wird erst, wenn wirklich eine Kategorie gewaehlt ist — ein Tipp auf eine
   Oberkategorie waehlt noch nichts aus.

   Markup: snippets/collection-categories-drawer.liquid
   Gestaltung: assets/mobile.css

   Das Skript setzt nur Klassen. Ob die etwas bewirken, entscheidet allein das CSS —
   die gesamte Overlay-Gestaltung steht in einer Medienabfrage bis 749px, auf dem
   Desktop laufen diese Klassen also ins Leere. Deshalb braucht es hier keine
   Breitenpruefung. */
(() => {
  // Ueber die Klassen und nicht ueber eine feste ID: Dasselbe Menue steckt im Shop
  // (#CollectionCategories) und auf den Blogseiten (#BlogCategories). Pro Seite gibt
  // es genau eines, ein querySelector genuegt also.
  const overlay = document.querySelector('.collection-categories');
  const toggle = document.querySelector('.collection-categories-toggle');
  if (!overlay || !toggle) return;

  // ── Oberkante: fest an der Unterkante der Kopfleiste ──────────────────────
  // Das CSS hatte hier zuerst Dawns --header-bottom-position benutzt. Die Variable
  // taugt dafuer aber nicht: Dawn schreibt sie AUSSCHLIESSLICH beim Oeffnen des
  // Hamburger-Menues (global.js, HeaderDrawer.openMenuDrawer) und danach nur noch bei
  // resize. Wer sie nie geoeffnet hat, hatte gar keinen Wert; wer sie einmal geoeffnet
  // hatte, einen von damals. Je nach Scrollstand sass das Menue deshalb woanders.
  //
  // Also selbst messen. Die Kopfleiste ist zudem nicht immer gleich hoch — beim
  // Scrollen klappt der Untertitel ein (base.css, .header-compact) — deshalb wird der
  // Wert beim Oeffnen UND waehrend das Menue offen ist nachgefuehrt.
  const header = document.querySelector('.section-header');

  const setTop = () => {
    if (!header) return;
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    overlay.style.setProperty('--cat-top', bottom + 'px');
  };

  // ── Tablet quer: Der Knopf gehoert IN die Kopfleiste ────────────────────────
  // Erster Versuch war position: fixed mit einer Oberkante aus --cat-sticky-top. Das
  // ging schief: Beim Scrollen klappt der Untertitel ein, die Kopfleiste wird niedriger,
  // und die Variable wird per Skript nachgefuehrt — bei schnellem Scrollen hinkt sie ein
  // Bild hinterher. Der Knopf sprang dadurch mal ueber, mal unter die beige Leiste.
  //
  // Jetzt wird er stattdessen in den Header EINGEHAENGT. Damit ist er ein normales
  // Rasterfeld darin und kann per Definition nicht mehr verrutschen — egal wie oft sich
  // die Hoehe aendert. Kein Nachfuehren, keine Variable, kein Hinterherhinken.
  //
  // Die Kopfleiste hat in diesem Band das Raster
  //     "heading heading heading" / "left-icons . icons"
  // — die Mitte der zweiten Zeile ist frei. Genau dorthin setzt ihn das CSS.
  const headerEl = document.querySelector('.header');
  const heimat = toggle.parentElement;
  const heimatNachbar = toggle.nextElementSibling;
  // Gilt jetzt auch im HOCHFORMAT ab 744px (iPad mini quer gehalten ist 1133 breit,
  // hochkant 744). Dort ist die Kopfleiste genauso aufgebaut wie im Querformat, und der
  // Knopf hat daneben denselben freien Platz in der Mitte der zweiten Zeile.
  // 744 statt 750, weil genau dieses Geraet gemeint ist; auf dem Handy (bis 743) bleibt
  // der Knopf an seinem angestammten Platz im Inhalt.
  const querBand = window.matchMedia(
    '(min-width: 750px) and (max-width: 1279.98px) and (orientation: landscape),' +
    '(min-width: 744px) and (max-width: 1279.98px) and (orientation: portrait)'
  );
  const platziere = () => {
    if (!headerEl || !heimat) return;
    if (querBand.matches) {
      if (toggle.parentElement !== headerEl) headerEl.appendChild(toggle);
    } else if (toggle.parentElement !== heimat) {
      heimat.insertBefore(toggle, heimatNachbar);
    }
  };
  platziere();
  querBand.addEventListener('change', platziere);

  let ticking = false;
  const trackTop = () => {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      ticking = false;
      if (overlay.classList.contains('is-open')) setTop();
    });
  };

  window.addEventListener('scroll', trackTop, { passive: true });
  window.addEventListener('resize', trackTop);

  // ── Oberkante fuer den KLEBENDEN Knopf ─────────────────────────────────
  // Dieselbe Messung wie oben, aber IMMER nachgefuehrt statt nur bei offenem Menue: Der
  // Knopf haengt ja dauerhaft unter der Kopfleiste, nicht nur waehrend das Menue offen ist.
  //
  // Warum gemessen und nicht --header-height benutzt: Die Variable setzt
  // sections/header.liquid nur beim Aufbau und bei resize. Beim Scrollen klappt der
  // Untertitel aber ein (base.css, .header-compact) und die Leiste wird niedriger —
  // der Knopf haette danach eine Luecke darueber. getBoundingClientRect().bottom liefert
  // die tatsaechliche Unterkante zu jedem Zeitpunkt.
  //
  // Geschrieben wird auf das <html>, nicht auf das Menue: Der Knopf ist dessen
  // Geschwister und kaeme an eine Variable am Menue nicht heran.
  const setStickyTop = () => {
    if (!header) return;
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    document.documentElement.style.setProperty('--cat-sticky-top', bottom + 'px');
  };

  let stickyTicking = false;
  const trackSticky = () => {
    if (stickyTicking) return;
    stickyTicking = true;
    requestAnimationFrame(() => {
      stickyTicking = false;
      setStickyTop();
    });
  };

  setStickyTop();
  window.addEventListener('scroll', trackSticky, { passive: true });
  window.addEventListener('resize', trackSticky);

  // Sperrt das Scrollen der Seite hinter dem offenen Menue. Ueber eine Klasse am
  // <body> und nicht ueber style.overflow, damit die Regel dort steht, wo auch das
  // uebrige Aussehen gepflegt wird.
  const BODY_CLASS = 'categories-open';

  const panels = overlay.querySelectorAll('[data-panel]');

  // Immer genau eine Ebene sichtbar.
  const showPanel = (name) => {
    let found = false;
    panels.forEach((panel) => {
      const match = panel.dataset.panel === name;
      panel.classList.toggle('is-current', match);
      if (match) found = true;
    });
    // Unbekannter Name (z.B. nach einer Menue-Aenderung im Admin): zurueck auf Ebene 1,
    // sonst stuende das Menue leer da.
    if (!found) showPanel('root');
    overlay.scrollTop = 0;
  };

  const setOpen = (open) => {
    // VOR dem Einblenden messen, sonst faehrt das Menue kurz an der alten Stelle auf.
    if (open) setTop();
    overlay.classList.toggle('is-open', open);
    document.body.classList.toggle(BODY_CLASS, open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    // Beim Schliessen auf die erste Ebene zuruecksetzen — beim naechsten Oeffnen
    // erwartet man den Anfang, nicht die zuletzt betrachtete Unterkategorie.
    if (!open) showPanel('root');
  };

  toggle.addEventListener('click', () => setOpen(!overlay.classList.contains('is-open')));

  const close = overlay.querySelector('.collection-categories__close');
  if (close) close.addEventListener('click', () => setOpen(false));

  // ── Die drei Striche schliessen die Kategorieauswahl ─────────────────────────
  // Die Kategorieauswahl liegt UEBER dem Hauptmenue (z-index 4 gegen die 3 der
  // Kopfleiste, siehe base.css / mobile.css). Ohne diese Zeilen oeffnete ein Tipp auf
  // die drei Striche das Hauptmenue unsichtbar darunter - der Knopf schiene tot.
  // Also: Wer die drei Striche antippt, will das Hauptmenue sehen. Die Kategorieauswahl
  // geht zu, Dawn oeffnet (oder schliesst) sein Menue wie gewohnt.
  // STILLGELEGT - frueher nur die drei Striche:
  //   const burger = document.querySelector('header-drawer summary');
  //   if (burger) burger.addEventListener('click', ...);
  // Dasselbe gilt fuer JEDES Menue, das aus der Kopfleiste aufklappt - allen voran die
  // Suche („Was suchen Sie?"): Deren Feld liegt zum Teil unterhalb der Kopfleiste und
  // damit unter der Kategorieauswahl. Also schliesst jeder Aufklapper im Header sie.
  document.querySelectorAll('.section-header summary').forEach((summary) => {
    summary.addEventListener('click', () => {
      if (overlay.classList.contains('is-open')) setOpen(false);
    });
  });

  // Ebene tiefer / Ebene hoeher. Ein Handler fuer alle Knoepfe, damit auch spaeter
  // ergaenzte Ebenen ohne Anpassung funktionieren.
  overlay.addEventListener('click', (event) => {
    const open = event.target.closest('[data-open]');
    if (open) {
      showPanel(open.dataset.open);
      return;
    }
    const back = event.target.closest('[data-back]');
    if (back) {
      showPanel(back.dataset.back);
      return;
    }
    // Ein Link ist eine echte Auswahl — hier darf zugemacht werden. Fuehrt er auf die
    // gerade angezeigte Kategorie, laedt der Browser nicht neu; ohne diese Zeile
    // bliebe das Menue dann offen stehen.
    if (event.target.closest('a')) setOpen(false);
  });

  // Escape schliesst, wenn man auf Ebene 1 ist, sonst eine Ebene hoch — wie man es
  // von verschachtelten Menues kennt.
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape' || !overlay.classList.contains('is-open')) return;
    const current = overlay.querySelector('[data-panel].is-current');
    const back = current && current.querySelector('[data-back]');
    if (back) showPanel(back.dataset.back);
    else setOpen(false);
  });

  // Beim Wechsel auf ein grosses Fenster (Drehen, Tablet) den gesperrten Scroll wieder
  // freigeben — dort gibt es kein Overlay, das ihn rechtfertigt.
  window.matchMedia('(max-width: 749px)').addEventListener('change', (event) => {
    if (!event.matches) setOpen(false);
  });
})();
